import { StatefulLoader } from '@mauriceguest/guest'
import { AbstractUserLoader } from '../../generated'

export default AbstractUserLoader

/** @constructor @extends {AbstractUserLoader} @suppress {checkTypes} */ function _UserLoader() {}
AbstractUserLoader.__implement(StatefulLoader,
 _UserLoader.prototype = /** @type {!AbstractUserLoader} */ ({
  async GetUser() {
   const{
    asIUserLoader:{setState:setState,props:{HOST:HOST}},
    asIStatefulLoader:{fetchJSON:fetchJSON},
   }=this
   const user=(await fetchJSON(`${HOST}/api/user`,{
    credentials:'include',
   }))||null
   setState({user:user})
  },
  async SignOut() {
   const {
    asIUserLoader:{setState:setState,props:{HOST:HOST}},
    asIStatefulLoader:{fetchJSON:fetchJSON},
   }=this
   // does credentials need to be included to sign out?
   const hasSignedOut=await fetchJSON(`${HOST}/api/user?${SIGN_OUT}`,{
    credentials:'include',
    method:'POST',
   })
   if(!hasSignedOut) return false

   setState({user:null})
   return true
  },
  async SignUp(form) {
   const{
    asIStatefulLoader:{fetchJSON:fetchJSON},
    props:{HOST:HOST},
   }=this
   const body=new FormData(form) // when changing to protobufs, encode the data.
   const res=await fetchJSON(`${HOST}/api/signup`, {
    body:body,
    credentials:'include',
    method:'POST',
   })
   return res
  },
  async SignIn(form) {
   // debugger
   const {
    asIStatefulLoader:{fetchJSON:fetchJSON},
    props:{HOST:HOST},
   } = this
   const body=new FormData(form)
   await new Promise((r)=>{
    setTimeout(r,100)
   })
   const res=await fetchJSON(`${HOST}/api/user?${SIGN_IN}`, {
    body, // just include action as hidden field on the form
    credentials:'include',
    method:'POST',
   })
   return res
  },
 }),
)

const SIGN_IN='c5b5f'
const SIGN_OUT='79d2b'
// const queryPQs={
//  checkUser:'bad39',
//  signIn:   'c5b5f',
//  signOut:  '79d2b',
// }
